var map = {
	"./en-US.json": [
		13141,
		3141
	],
	"./es-MX.json": [
		29781,
		9781
	],
	"./hi-IN.json": [
		77378,
		7378
	],
	"./pt-BR.json": [
		5896,
		5896
	],
	"./ur-PK.json": [
		27856,
		5475
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 39783;
module.exports = webpackAsyncContext;